var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Appointment-expand",
    transform: "translate(-436.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(225.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(191.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1DB4CF",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7636675,14.0558846 C24.5503518,14.0558846 26.9356074,14.2285316 28.3696325,16.3820767 L28.7055399,16.8868593 L28.2221024,17.2516555 C27.5314712,17.7727685 26.2713362,18.7233561 26.2713362,20.606315 C26.2713362,22.8364539 27.6984605,23.6941172 28.3840769,24.1066186 C28.6867236,24.2886952 29,24.4764296 29,24.887045 C29,25.1551452 26.8602565,30.9119477 23.752995,30.9119477 C22.9926706,30.9119477 22.4552273,30.6834089 21.9811766,30.4818731 C21.5015109,30.2778083 21.0877237,30.1020324 20.4039933,30.1020324 C20.0574133,30.1020324 19.6191521,30.2658928 19.1551738,30.4398257 C18.5211201,30.6764653 17.8034432,30.9452084 16.9891131,30.9452084 L16.967768,30.9452084 C13.7016609,30.9263921 11,24.2591635 11,20.8636997 C11,15.3172197 15.1608029,14.1029467 16.7643462,14.1029467 C17.486995,14.1029467 18.2586349,14.3867343 18.9392363,14.6378612 C19.4151731,14.8130371 19.9073972,14.9938708 20.1811551,14.9938708 C20.3450155,14.9938708 20.7311569,14.84004 21.0720792,14.7050684 C21.7991428,14.4156231 22.7038683,14.0558846 23.7574097,14.0558846 L23.7636675,14.0558846 Z M24.0865878,9 C24.1675108,11.9178555 22.0807872,13.9421295 19.9965068,13.8151731 C19.6530557,11.4866236 22.0805301,9 24.0865878,9 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApple);
export default __webpack_public_path__ + "static/media/icApple.d55b1a2ab755f604592199d3cda5b91a.svg";
export { ForwardRef as ReactComponent };